import React, { useEffect, useRef, memo } from 'react';
import { getChartData } from '../../store/crypto/cryptoActions';
import { useDispatch } from 'react-redux';

const TradingViewWidget = ({ symbol = "BTCUSDT", exchange = "BINANCE", height = 500, coinTypeId }) => {
  const containerRef = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const container = containerRef.current; // Store ref value in variable

    // Clear any existing widget
    if (container) {
      container.innerHTML = '';
    }

    // Create the script element
    const script = document.createElement('script');
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js';
    script.type = 'text/javascript';
    script.async = true;
    script.innerHTML = JSON.stringify({
      autosize: false,
      width: "100%",
      height: height,
      symbol: `${exchange}:${symbol}`,
      interval: "15",
      timezone: "Etc/UTC",
      theme: "dark",
      style: "1",
      locale: "en",
      allow_symbol_change: false,
      calendar: false,
      support_host: "https://www.tradingview.com",
      hide_top_toolbar: false,
      hide_legend: false,
      save_image: true,
      hide_volume: false,
      toolbar_bg: "#1A1A1A",
      enable_publishing: false,
      withdateranges: true,
      details: false,
      hotlist: false,
      show_popup_button: false,
      studies: [
        "Volume@tv-basicstudies"
      ],
      container_id: "tradingview_chart"
    });

    // Create widget container
    const widgetContainer = document.createElement('div');
    widgetContainer.className = 'tradingview-widget-container__widget';
    widgetContainer.id = 'tradingview_chart';
    widgetContainer.style.height = `${height}px`;
    widgetContainer.style.width = '100%';

    if (container) {
      container.appendChild(widgetContainer);
      container.appendChild(script);
    }

    // Force iframe height after widget loads
    const timeoutId = setTimeout(() => {
      const iframe = container?.querySelector('iframe');
      if (iframe) {
        iframe.style.height = `${height}px`;
      }
    }, 1000);

    return () => {
      clearTimeout(timeoutId);
      if (container) {
        container.innerHTML = '';
      }
    };
  }, [symbol, exchange, height]);

   // Fetch chart data on mount with 15m timeframe and when timeframe changes
  useEffect(() => {
    if (!coinTypeId) {
      console.log('⚠️ No coinTypeId provided');
      return;
    }

    dispatch(
      getChartData({
        coinTypeId,
      })
    );
  }, [coinTypeId, dispatch]);

  return (
    <>
      <style>
        {`
          .tradingview-widget-container iframe {
            height: ${height}px !important;
          }
          .tradingview-widget-container__widget {
            height: ${height}px !important;
          }
        `}
      </style>
      <div 
        className="tradingview-widget-container" 
        ref={containerRef} 
        style={{ 
          height: `${height}px`, 
          width: '100%',
          minHeight: `${height}px`
        }}
      />
    </>
  );
};

export default memo(TradingViewWidget);